export const permissionCheck = (list, reqd) => {
  for (var i = 0, j = list.length; i < j; i++) {
    if (list[i] === reqd) {
      return true;
    }
  }
  return false;
};
